import Vue from 'vue';
import App from '@/index.vue';
import router from '@/router';
import store from '@/store'
import hui from "h_ui";
import axios from 'axios'; //引入axios
import http from '@/assets/utils/httpRequest.js';
import $ from '@/assets/utils/keyboard.js';
import i18n from '@/assets/lang';
import selfMsgBox from '@/components/SelfMsgBox'
import Table from '@hui/table'
import floatFmt from '@/assets/utils/float-fmt';
import moneyFmt from '@/assets/utils/money-fmt'
import dateFmt from '@/assets/utils/date-fmt'
import fundFmt from '@/assets/utils/fund-fmt'
import filters from '@/assets/filters/index.js'
import '@/assets/tool/lib-flexible/flexible'
import "h_ui/dist/h_ui.min.css";
import '@/assets/scss/index.scss';
import '@hui/table/dist/table.css'
import '@/assets/css/keyboard_letter.css';
import { each , getTips } from '@/assets/utils/common';
import form from '@/assets/utils/form';

window.jQuery = $;
window.$ = $;

// 注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
// 挂载全局
Vue.prototype.$form = form;
Vue.prototype.$http = http;
Vue.prototype.$axios = axios;
// 弹框
Vue.prototype.$selfMsgBox = selfMsgBox;
// forEach
Vue.prototype.$each = each;
Vue.prototype.$float = floatFmt;
Vue.prototype.$money = moneyFmt;
Vue.prototype.$date = dateFmt;
Vue.prototype.$fund = fundFmt;
Vue.prototype.$getTips = getTips;

Vue.use(hui);
Vue.use(Table)
Vue.use({
  size: 'default',
  i18n: (key, value) => i18n.t(key, value)
})

new Vue({
  render: h => h(App),
  i18n,
  router,
  store
}).$mount('#app')
